import React from 'react';

import { Card, Group, Stack, Text } from '@mantine/core';
import { WHITEBOARD_SIZES } from 'components/Workout/whiteboardDisplay';
import { SCORE_TYPE_LABEL_MAP, ScoreTypeEnum } from 'types/enums';

interface PreviewMovementCardProps {
  movementName: string | null;
  scoreType: ScoreTypeEnum;
  enlarged?: boolean;
  /** Rendered opposite the movement name. Omit it and the card renders as before. */
  extra?: React.ReactNode;
}

const PreviewMovementCard = ({
  movementName,
  scoreType,
  enlarged = false,
  extra,
}: PreviewMovementCardProps): JSX.Element => {
  const prescription = (
    <Stack spacing={enlarged ? 'xs' : 2}>
      {movementName !== null && (
        <Text weight={600} size={enlarged ? WHITEBOARD_SIZES.movementName : 'sm'}>
          {movementName || 'Unknown Movement'}
        </Text>
      )}
      <Text size={enlarged ? WHITEBOARD_SIZES.scoreType : 'sm'} color='dimmed'>
        {SCORE_TYPE_LABEL_MAP[scoreType]}
      </Text>
    </Stack>
  );

  return (
    <Card p={enlarged ? 'lg' : 'sm'} withBorder radius='md' sx={theme => ({ backgroundColor: theme.white })}>
      {extra ? (
        <Group position='apart' align='flex-start' noWrap>
          {prescription}
          {extra}
        </Group>
      ) : (
        prescription
      )}
    </Card>
  );
};

export default PreviewMovementCard;
